module.exports = __webpack_public_path__ + "img/dashboard_new_catalog_order.52fa363.png";